module.exports = __webpack_public_path__ + "components/flag/static/square/ke-5218718e6a009afff908b7d5e39da8a9.svg";